module.exports = __webpack_public_path__ + "img/20211111111345450wh8.232e045b.jpg";